import React, { useState, useEffect } from "react";
import Utils from "Utils";
import DataGrid, { Column } from "devextreme-react/data-grid";
import { connect } from "react-redux";
import Api from "Api/Api";
import { Popup } from "devextreme-react";
import InvestorView from "components/AdminComponents/InvestorView";
import moment from "moment";
import Filter from "components/common/Filters";
import Paginator from "components/common/Paginator";
import { navigate } from "@reach/router";
import Reminders from "components/AdminComponents/Reminders";
import { useUrlFilter } from "Hooks/utils";
import { isAllowed } from "permissions";
import { Permissions } from "permissions/constants";
import { InvestorCrud } from "components/forms/InvestorCrud";
import { DeleteModal } from "components/common/DeleteModal";

function InvestorsPage(props) {
  const { dispatch, formFields } = props;

  const [investors, setInvestors] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedInvestor, setSelectedInvestor] = useState(null);
  const [popupType, setPopupType] = useState(null);
  const [count, setCount] = useState(0);
  const [filters, setFilters] = useUrlFilter();
  const [openInvestorForm, setOpenInvestorForm] = useState(false);
  const [dataOfInvestorToEdit, setDataOfInvestorToEdit] = useState(null);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [investorToBeDeleted, setInvestorToBeDeleted] = useState(null);

  useEffect(() => {
    Utils.getFormFields();
    dispatch({
      type: "SectionSelected",
      payload: "Investors",
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (filters) {
      const page = filters?.page;
      delete filters?.page;
      loadData(page, filters);
    }
  }, [filters]); // eslint-disable-line react-hooks/exhaustive-deps

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };
  const popupData = (data, type) => {
    setSelectedInvestor(data);
    setPopupType(type);
    togglePopup();
  };
  const investorRemoved = async (record) => {
    // record.data will consist of the row data to be deleted
    const response = await Api.deleteInvestor(record.id);
    if (response.status !== 200) {
      Utils.notify(
        Utils.errorMessageGenerator(response.data),
        "warning",
        4000
      );
    } else {
      const updatedListOfInvestors = [...investors].filter(investor => {
        return investor.id !== record.id;
      });
      setInvestors(updatedListOfInvestors);
      Utils.notify("Investor deleted successfully!", "success", 4000);
    }
  };

  const processCountries = (data, operation) => {
    if ("invest_in_countries" in data) {
      if (data.invest_in_countries) {
        if (operation === "compress") {
          data.invest_in_countries = data.invest_in_countries.join(",");
        } else if (operation === "decompress") {
          data.invest_in_countries = data.invest_in_countries.split(",");
        }
      }
    }
    return data;
  };
  const changeInvestmentCountriesData = (data) => {
    data.forEach((record) => {
      if (record.invest_in_countries) {
        record = processCountries(record, "decompress");
      }
    });
    return data;
  };
  const prepareEditor = (data) => {
    try {
      if (data.row.values[0] && data.dataField === "password") {
        data.cancel = true;
      }
    } catch (error) { }
  };
  const renderComponent = () => {
    switch (popupType) {
      case "view":
        return <InvestorView investor={selectedInvestor} />;
      case "reminder":
        return <Reminders id={selectedInvestor} type={"investor"} />;
      default:
        break;
    }
  };
  const customExport = (excel) => {
    excel.fileName = `Investor's Data-${moment(new Date()).format("ll")}`;
    excel.component.beginUpdate();
    excel.component.columnOption("id", "visible", true);
    excel.component.columnOption("username", "visible", true);
    excel.component.columnOption("First Name", "visible", false);
    excel.component.columnOption("Last Name", "visible", false);
    excel.component.columnOption("secondary_email", "visible", true);
    excel.component.columnOption("contact_number", "visible", true);
    excel.component.columnOption("dob", "visible", true);
    excel.component.columnOption("country", "visible", true);
    excel.component.columnOption("invest_in_countries", "visible", true);
    // excel.component.columnOption("investment_type", "visible", true);
    excel.component.columnOption("city", "visible", true);
    excel.component.columnOption("address", "visible", true);
    excel.component.columnOption("linkedin", "visible", true);
    excel.component.columnOption("twitter", "visible", true);
    excel.component.columnOption("facebook", "visible", true);
    excel.component.columnOption("status", "visible", true);
    excel.component.columnOption("contact_person", "visible", true);
    excel.component.columnOption("comment_box", "visible", true);
    excel.component.columnOption("primary_email", "visible", true);
    excel.component.columnOption("type", "visible", true);
    excel.component.columnOption("startup_invested_text", "visible", true);
    excel.component.columnOption("priority", "visible", true);
  };
  const preparingRow = (row) => {
    if (row.rowType === "data" && row.data.status === "inactive") {
      row.rowElement.style.backgroundColor = "#f5b8ff";
    }
  };
  const toolbarPreparing = (e) => {
    let toolbarItems = e.toolbarOptions.items;
    toolbarItems.push({
      widget: "dxButton",
      options: {
        text: "* Purples are inactive investors",
        stylingMode: "text",
        hoverStateEnabled: false,
      },
      location: "before",
    });
    if (isAllowed(Permissions.ADD_INVESTOR)) {
      toolbarItems.push({
        widget: "dxButton",
        options: {
          text: "+",
          onClick: () => { setOpenInvestorForm(true) }
        },
        location: "after",
      });
    }
  };
  const formatType = (data, operation = "decompress") => {
    if (operation === "decompress") {
      return data.map((record) => {
        return {
          ...record,
          type: record.type.split(","),
        };
      });
    } else {
      if ("type" in data) {
        data.type = data.type.join(",");
      }
      return data;
    }
  };
  const loadData = (page = 1, filters) => {
    dispatch({ type: "toggleLoad" });
    Api.getAllInvestor(page, filters).then((response) => {
      dispatch({ type: "toggleLoad" });
      if (response.status === 200) {
        let investorsData = changeInvestmentCountriesData(
          response.data.results
        );
        investorsData = formatType(investorsData);
        setInvestors(investorsData);
        setCount(response.data.count);
      } else if (response.status === 404) {
        setFilters({ page: 1 });
      }
    });
  };

  const submitHandler = (payload, created) => {
    if (created) {
      setInvestors([...investors, payload]);
    } else {
      const updatedData = [...investors].map(startup => {
        return startup.id === payload.id ? payload : startup
      })
      setInvestors(updatedData);
    }
  }

  return (
    <div className="row" style={{ paddingLeft: 20 }}>
      <div className="col-lg-12">
        <Filter type="investor" />
        <div className="card">
          <div className={`card-header card-header-primary`}>
            <div className="row">
              <div className="col-lg-12">
                <div style={{ textTransform: "capitalize" }}>
                  <h4>Investors</h4>
                </div>
              </div>
            </div>
          </div>
          <div className="investors card-body">
            <DataGrid
              dataSource={investors}
              export={{ enabled: isAllowed(Permissions.EXPORT_INVESTOR) }}
              // searchPanel={{ visible: true }}
              wordWrapEnabled={true}
              onExporting={customExport}
              onEditorPreparing={prepareEditor}
              hoverStateEnabled={true}
              onRowPrepared={preparingRow}
              onToolbarPreparing={toolbarPreparing}
            >
              <InvestorCrud
                onClose={() => {
                  setOpenInvestorForm(false)
                  setDataOfInvestorToEdit(null);
                }}
                visible={openInvestorForm}
                dynamicFields={formFields}
                data={dataOfInvestorToEdit}
                onSubmit={submitHandler}
              />
              <Column dataField="id" visible={false} />
              <Column dataField="username" visible={false} />
              <Column
                dataField="username"
                caption="First Name"
                allowSorting={false}
                cellRender={(e) => {
                  return (
                    <>
                      {e?.row?.data?.username?.split(" ")[0]}{" "}
                      <span
                        className={`badge badge-pill ${e.row.data.reminder_active
                          ? "badge-success"
                          : "badge-warning"
                          }`}
                        title={e.row.data.reminder}
                      >
                        <i
                          className="material-icons pointer"
                          style={{ fontSize: 14 }}
                          onClick={() => popupData(e.row.data.id, "reminder")}
                        >
                          add_alert
                        </i>
                      </span>
                    </>
                  );
                }}
              />
              <Column
                dataField="username"
                allowSorting={false}
                caption="Last Name"
                cellRender={(e) => {
                  return (
                    <>{e?.row?.data?.username?.split(" ").slice(1).join(" ")}</>
                  );
                }}
              />
              <Column dataField="primary_email" visible={false} />
              <Column dataField="secondary_email" visible={false} />
              <Column dataField="contact_number" visible={false} />
              <Column dataField="dob" visible={false} />
              <Column dataField="password" visible={false} />
              <Column dataField="country" visible={false} />
              <Column dataField="invest_in_countries" visible={false} />
              {/* <Column dataField="investment_type" visible={false} /> */}
              <Column dataField="city" visible={false} />
              <Column dataField="address" visible={false} />
              <Column dataField="linkedin" visible={false} />
              <Column dataField="twitter" visible={false} />
              <Column dataField="facebook" visible={false} />
              <Column dataField="status" caption="Status" visible={false} />
              <Column dataField="fund_name" allowSorting={false} />
              <Column dataField="priority" visible={false} />
              <Column dataField="designation" allowSorting={false} />
              <Column
                dataField="primary_contact"
                allowSorting={false}
                cellRender={(row) => {
                  return (
                    <span>{row.data.primary_contact ? "Pri" : "Sec"}</span>
                  );
                }}
              />
              <Column
                dataField="min_ticket_size"
                allowSorting={false}
                caption={"Minimum Ticket ($)"}
              />
              <Column
                dataField="max_ticket_size"
                allowSorting={false}
                caption={"Maximum Ticket ($)"}
              />
              <Column dataField="website" visible={false} />
              <Column dataField="industries" allowSorting={false} />
              <Column dataField="client_segments" allowSorting={false} />
              <Column dataField="preferred_stages" allowSorting={false} />
              <Column dataField="sectors" allowSorting={false} />
              <Column dataField="no_sectors" allowSorting={false} />
              <Column dataField="type" visible={false} />
              <Column dataField="contact_person" visible={false} />
              <Column dataField="comment_box" visible={false} />
              <Column dataField="reminder_date" visible={false} />
              <Column dataField="reminder" visible={false} />
              <Column dataField="startup_invested_text" visible={false} />
              <Column
                alignment="center"
                cellRender={(row) => {
                  return (
                    <span
                      className="badge badge-pill badge-success pointer"
                      onClick={() => navigate(`/arrange/${row.data.id}`)}
                    >
                      Arrange
                    </span>
                  );
                }}
              />
              <Column
                alignment="center"
                cellRender={(row) => {
                  return (
                    <span
                      className="badge badge-pill badge-info pointer"
                      onClick={() => popupData(row.data, "view")}
                    >
                      View
                    </span>
                  );
                }}
              />
              <Column
                alignment="center"
                cellRender={(row) => {
                  return (
                    <span
                      className="action-img flex gap-10"
                    >
                      <img src="/logos/edit.png" alt="pencil-icon" onClick={() => {
                        setDataOfInvestorToEdit(row.data)
                        setOpenInvestorForm(true)
                      }} />
                      {isAllowed(Permissions.DELETE_INVESTOR) && <img src="/logos/delete.png" alt="trash-icon" onClick={() => {
                        setDeleteModalVisible(true);
                        setInvestorToBeDeleted(row.data);
                      }} />}

                    </span>
                  );
                }}
              />
            </DataGrid>
          </div>
          <DeleteModal
            title={"Delete investor?"}
            subheading={`Do you want to delete this investor ${investorToBeDeleted?.username}?`}
            isOpen={deleteModalVisible}
            onCancel={() => {
              setDeleteModalVisible(false);
              setInvestorToBeDeleted(null);
            }}
            onOk={async () => {
              await investorRemoved(investorToBeDeleted);
              setDeleteModalVisible(false);
            }}
          />
          <Paginator totalItemsCount={count} pageRangeDisplayed={5} />
          <Popup
            visible={showPopup}
            onHiding={togglePopup}
            closeOnOutsideClick={true}
            contentComponent={renderComponent}
            height={"90%"}
            width={"90%"}
          />
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    section: state.section,
    formFields: state.formFields,
  };
}

export default connect(mapStateToProps)(InvestorsPage);
